import { render } from "./App.vue?vue&type=template&id=77a8e1b7&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=77a8e1b7&lang=scss"

import exportComponent from "/var/lib/jenkins/jobs/advbet-github/jobs/advbet-landing-page/branches/master/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__